<template>
    <div style="text-align:left">
        <Breadcrumb style="margin: 0px 10px 20px">
            <BreadcrumbItem to="/home">首页</BreadcrumbItem>
            <BreadcrumbItem>查看详情</BreadcrumbItem>
        </Breadcrumb>
        <div class="statistics">
            <br>
            <Row>
                <Col span="8">
                    <div class="box">
                        <div class="title">                     
                            投放天数
                        </div>
                        <div class="count">
                            {{ad_days}}天
                        </div>
                    </div>
                </Col>
                <Col span="8">
                    <div class="box">
                        <div class="title">
                            曝光次数
                        </div>
                        <div class="count">
                            {{total_exposure_count}}次
                        </div>
                    </div>
                </Col>
                <Col span="8">
                    <div class="box">
                        <div class="title">
                            点击次数
                        </div>
                        <div class="count">
                            {{total_click_count}}次
                        </div>
                    </div>
                </Col>
            </Row>
            <Row class="row" style="margin-top:0px">
                <span style="line-height:40px">数据趋势</span>
            </Row>
            <Row class="row">
                <Col span="8">
                    <Select v-model="model" style="width:200px" @on-change="handleChange">
                        <Option value="show_count">曝光量</Option>
                        <Option value="click_count">点击数</Option>
                    </Select>
                </Col>
            </Row>
            <div id="echart"></div>
            <Row class="row" style="margin-top:0px">
                <span style="line-height:40px">历史数据统计</span>
            </Row>
            <Table :columns="columns" :data="historical_data" style="margin:20px"></Table>
            <Page show-total @on-change="changePage" style="margin-top: 10px; text-align: right" :total="total_count" :page-size="20"/>
            <br>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import * as echarts from 'echarts';
import{homePlacementData, placementHistoryFlow}from "@/request/api"
export default {
    name: 'statistics',
    components: {
        
    },
    data () {
        return {
            placement_id: '',
            plan_id: '',
            ad_days: 0,
            total_exposure_count: 0,
            total_click_count: 0,
            model: 'show_count',
            exposure_count_list: [],
            click_connt_list: [],
            date_list: [],
            data: [],
            chart_name: '曝光量',
            columns: [
                {
                    title: '日期',
                    key: 'date',
                    align: 'center'
                },
                {
                    title: '曝光次数',
                    key: 'exposure_count',
                    align: 'center'
                },
                {
                    title: '点击次数',
                    key: 'click_count',
                    align: 'center'
                }
            ],
            historical_data: [],
            total_count: 0,
            page: 1
        }
    },
    methods:{
        getHomePlacementData(placement_id, plan_id){
            homePlacementData({placement_id, plan_id}).then(res=>{
                if(res.data.code==200){
                    this.ad_days = res.data.data.statistics_data.ad_days
                    this.total_exposure_count = res.data.data.statistics_data.total_exposure_count
                    this.total_click_count = res.data.data.statistics_data.total_click_count
                    this.exposure_count_list = res.data.data.statistics_data.daily_flow_30.exposure
                    this.click_count_list = res.data.data.statistics_data.daily_flow_30.click
                    this.date_list=res.data.data.statistics_data.daily_flow_30.date
                    this.data=res.data.data.statistics_data.daily_flow_30.exposure
                    this.drawChart()
                }else{
                    this.$Message.success(res.data.msg);
                }
            })
        },
        getPlacementHistoryFlow(page,page_size,placement_id, plan_id){
            placementHistoryFlow({page,page_size,placement_id, plan_id}).then(res=>{
                if(res.data.code==200){
                    this.historical_data=res.data.data.statistics_data.daily_flow
                    this.total_count=res.data.data.statistics_data.total
                }
            })
        },
        drawChart(){
            var Echart = echarts.init(document.getElementById('echart'));
            var option1  = {
                xAxis: {
                    type: 'category',
                    data: this.date_list
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: this.data,
                    type: 'bar',
                    name: this.chart_name
                }],
                legend: {
                    show: true,
                    x:'center',
                    y:'bottom'
                },
                grid: {
                    top: 30
                },
                tooltip : {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                }
            };

            Echart.setOption(option1);
            window.addEventListener("resize", () => { Echart.resize();});
        },
        handleChange(value){
            if(value=='show_count'){
                this.chart_name = '曝光量'
                this.data = this.exposure_count_list
                this.drawChart()
            }else if(value=='click_count'){
                this.chart_name = '点击数'
                this.data = this.click_count_list
                this.drawChart()
            }
        },
        changePage(page){
            this.getPlacementHistoryFlow(page,20);
            this.page=page
        }
    },
    created() {
        Cookies.set('active_name', '1')
        this.placement_id = this.$route.query.placement_id
        this.plan_id = this.$route.query.plan_id
        this.getHomePlacementData(this.placement_id,this.plan_id)
        this.getPlacementHistoryFlow(1,20,this.placement_id,this.plan_id)
    },
    mounted(){
    }
}
</script>
<style scoped>
.banner{
  width: 100%;
  max-height: 120px;
  min-height: 120px;
  /* border:1px solid; */
  background: white;
}
.statistics{
  width: 100%;
  /* border:1px solid; */
  background: white;
  margin-top: 20px;
}
.row{
  margin: 10px 20px 10px;
}
.box{
  width: 200px;
  height: 120px;
  border:1px solid;
  margin: 0px 20px 20px;
}
.box .count{
  width: 100%;
  height: 70%;
  line-height: 60px;
  text-align: center;
  /* font-display: center; */
  font-size: 24px;
}
.box .title{
    text-align: left;
    font-size: 14px; 
    margin:10px 10px 0px;
}
#echart{
    margin:20px 20px 0px;
    width: 100%;
    height: 400px
}
</style>



// WEBPACK FOOTER //
// src/views/Statistics.vue